import { render, staticRenderFns } from "./JobWrapper.vue?vue&type=template&id=1873c580&"
import script from "./JobWrapper.vue?vue&type=script&lang=js&"
export * from "./JobWrapper.vue?vue&type=script&lang=js&"
import style0 from "./JobWrapper.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports